import React, { useRef, useEffect } from "react";
import * as d3 from "d3";
export const LoanComposition: React.FC<any> = ({ data }) => {
    const year = data.loan_composition.focus_quarter.year;
    const quarter = data.loan_composition.focus_quarter.quarter;
    const chartRef = useRef<SVGSVGElement | null>(null);
    const colors = [
        "#0340a6",
        "#7c8eff",
        "#60e0e2",
        "#4cadee",
        "#2782b3",
        "#05105a",
    ];
    useEffect(() => {
        const svg = d3.select(chartRef.current);
        svg.selectAll("*").remove();
     
        const width = 150;
        const height = 150;
        const radius = Math.min(width, height) / 2;
     
        const pieData = Object.keys(data.loan_composition.focus_quarter)
          .map((key) => ({
            label: data.loan_composition.focus_quarter[key].label,
            value: data.loan_composition.focus_quarter[key].percentage,
          }))
          .filter((d) => d.value > 0);
     
        const svgElement = svg
          .attr("width", width)
          .attr("height", height)
          .append("g")
          .attr("transform", `translate(${width / 2}, ${height / 2})`);
     
        const pie = d3
          .pie<{ label: string; value: number }>()
          .value((d) => d.value)
          .sort(null);
     
        const arc = d3
          .arc<d3.PieArcDatum<{ label: string; value: number }>>()
          .innerRadius(0)
          .outerRadius(radius);
     
        const pieDataProcessed = pie(pieData);
     
        const slices = svgElement
          .selectAll("path")
          .data(pieDataProcessed)
          .enter()
          .append("path")
          .attr("d", arc)
          .attr("fill", (_d, i) => colors[i % colors.length])
          .attr("stroke", "white")
          .attr("stroke-width", 0);
     
        const textLabels = svgElement
          .selectAll("text")
          .data(pieDataProcessed)
          .enter()
          .append("text")
          .attr("transform", (d) => `translate(${arc.centroid(d)})`)
          .attr("text-anchor", "middle")
          .text((d) => d.data.value + "%")
          .style("font-size", "12px")
          .style("fill", "#fff")
          .style("opacity", 0); // Initially hide the text
     
        slices
         // @ts-ignore
          .on("mouseenter", function (event, d) {
            d3.select(this)
              .transition()
              .duration(300)
              .attr("transform", "scale(1.1)");
            const index = pieDataProcessed.indexOf(d);
            textLabels
              .filter((_d, i) => i === index)
              .transition()
              .duration(300)
              .style("opacity", 1);
          })  
          // @ts-ignore
          .on("mouseleave", function (event, d) {
            d3.select(this)
              .transition()
              .duration(300)
              .attr("transform", "scale(1)");
            const index = pieDataProcessed.indexOf(d);
            textLabels
              .filter((_d, i) => i === index)
              .transition()
              .duration(300)
              .style("opacity", 0);
          });
      }, [data]);
  
    const dataGet = { ...data };
    let focusQuarter = { ...dataGet.loan_composition.focus_quarter };
    if (focusQuarter) {
        const keysToRemove = ["quarter", "year"];
        keysToRemove.forEach((key) => delete focusQuarter[key]);
    }
    return (
        <div className="loanComp-section">
            <svg ref={chartRef} style={{ overflow: "visible" }}></svg>
            <div className="loan-text-graph-section">
                <div className="loanComp-year-heading">
                    {year} <span>Q{quarter}</span>
                </div>
                {Object.keys(focusQuarter)
                    .filter((key) => {
                        const label = focusQuarter[key].label;
                        return label !== "";
                    })
                    .map((key, index) => {
                        const item = focusQuarter[key];
                        return (
                            <div key={key} className="loanComp-progressive-section">
                                <span>{item.label}</span>
                                <div
                                    style={{
                                        marginBottom: 5,
                                    }}
                                >
                                    <span className="percentage-loanComp">
                                        {item.percentage}%
                                    </span>
                                </div>
                                <div className="loanProgressiveBarStatic">
                                    <div
                                        className="loanProgressiveBarDynamic"
                                        style={{
                                            width: `${item.percentage}%`,
                                            backgroundColor: colors[index % colors.length],
                                        }}
                                    ></div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
